import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?url';
import { setWorkerUrl, type StyleSpecification } from 'maplibre-gl';

// Explicit worker URL: bundlers (incl. Vite dev pre-bundling) cannot resolve MapLibre's relative worker file. In a
// production build the worker and its shared chunk are emitted side by side under maplibre/ (apps/web/build-plugins).
setWorkerUrl(import.meta.env.DEV ? workerUrl : `${import.meta.env.BASE_URL}maplibre/maplibre-gl-worker.mjs`);

export const cssVar = (name: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim();

/** Raster tiles (default: OpenStreetMap). Production should use self-hosted or contracted tiles (D7, OSM tile policy). */
const TILES = import.meta.env.VITE_MAP_TILES || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
const ATTRIBUTION =
  import.meta.env.VITE_MAP_ATTRIBUTION ||
  '© <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors';

export function baseStyle(theme: 'light' | 'dark'): string | StyleSpecification {
  const url = theme === 'dark' ? import.meta.env.VITE_MAP_STYLE_DARK : import.meta.env.VITE_MAP_STYLE_LIGHT;
  if (url) return url;
  // Dark theme without a dedicated dark style: invert brightness and rotate hue of the same raster tiles.
  const dark = theme === 'dark';
  return {
    version: 8,
    sources: {
      base: { type: 'raster', tiles: [TILES], tileSize: 256, maxzoom: 19, attribution: ATTRIBUTION },
    },
    layers: [
      { id: 'bg', type: 'background', paint: { 'background-color': cssVar('--map-bg') } },
      {
        id: 'base',
        type: 'raster',
        source: 'base',
        paint: dark
          ? {
              'raster-saturation': -1,
              'raster-brightness-min': 0.86,
              'raster-brightness-max': 0.1,
              'raster-contrast': 0.12,
              'raster-opacity': 0.85,
            }
          : { 'raster-saturation': -0.55, 'raster-contrast': -0.05, 'raster-opacity': 0.9 },
      },
    ],
  };
}
